import React from 'react'
import { RotatingLines } from 'react-loader-spinner';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import { cargoLeads } from '../../../../../../redux/cargo-lead/action';
import { currency } from '../../../../../../common/services/common.service';

export default function ModalQuotesDetailsComponent({
    selectedVehicleItem, dropLocations, pickupLocations, quoteDetails, enablePlaceOrder, handlePayment, isLoading, paymentSettings, paymentSelectedInput, handlePaymentInput }: any) {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const handleBookLater = () => {
        dispatch(cargoLeads.resetAction({ actionType: 'create' }))
        navigate('/customer/bookings')
    }
    const items = [
        {
            name: 'Cash',
            description: 'Cash on delivery',
            value: 10,
            checked: '',
            imageUrl: require('../../../../../../assets/img/cash.png'),
            show: paymentSettings?.result?.items?.MarketplaceSettings?.EnableForCOD,

        },
        {
            name: 'Online',
            description: 'Payment gateway',
            value: 20,
            checked: 'checked',
            imageUrl: require('../../../../../../assets/img/ccAvenue.png'),
            show: paymentSettings?.result?.items?.MarketplaceSettings?.EnableForOnline,
        },
        {
            name: 'Wallet',
            description: 'Wallet',
            value: 40,
            checked: '',
            imageUrl: require('../../../../../../assets/img/wallet.png'),

        },
    ];


    return (

        <div className="w-full max-w-md p-4 bg-white mx-auto">
            <h1 className="text-lg font-normal mb-4 text-center">Confirm Order</h1>


            {/* Top Section */}
            <div className="p-4 border-b-2 border-gray-300">
                <div className='text-lg font-semibold mb-4'>Order Details</div>
                <div className="w-full grid grid-cols-1 gap-4">
                    <div className="pb-4">
                        <label className="text-sm font-semibold block">Vehicle Type</label>
                        <label className="text-sm block mt-1">{selectedVehicleItem?.VehicleType}</label>
                    </div>
                    <div className="pb-4">
                        <label className="text-sm font-semibold block">Total Distance</label>
                        <label className="text-sm block mt-1">{quoteDetails?.result?.Records[0]?.message?.order?.quote?.TotalDistance} km</label>
                    </div>
                    <div className="pb-4">
                        <label className="text-sm font-semibold block">Amount Quoted</label>
                        <label className="text-sm block mt-1">{currency(quoteDetails?.result?.Records[0]?.message?.order?.quote?.price?.value)}</label>
                    </div>
                    <div className="pb-4">
                        <label className="text-sm font-semibold block">Pickup Address</label>
                        <label className="text-sm block mt-1">{pickupLocations?.description}</label>
                    </div>
                    <div className="pb-4">
                        <label className="text-sm font-semibold block">Drop Address</label>
                        <label className="text-sm block mt-1">{dropLocations?.description}</label>
                    </div>
                </div>
            </div>

            {/* Bottom Section */}
            <div className="p-4">
                <div className="bg-white">
                    <div className="flex flex-col justify-center items-start space-y-4">
                        <div className='text-lg font-semibold'>Payment Details</div>
                        <div className='text-sm font-normal font-semibold'>Payment Method</div>
                        <div className='grid grid-cols-2 gap-4 w-full'>
                            {items?.map((item: any, index: any) => (
                                item.show && (
                                    <div className="flex flex-row items-center w-full" key={index}>
                                        <input
                                            name={item?.name}
                                            type="radio"
                                            checked={paymentSelectedInput == String(item?.name)}
                                            className="mx-2 rounded cursor-pointer transform scale-125"
                                            onChange={(event: any) => handlePaymentInput(event, item)}
                                            value={item?.name}
                                        />
                                        {item?.name}
                                    </div>
                                )
                            ))}
                        </div>

                        <div className='w-full flex flex-col space-y-3'>
                            {paymentSelectedInput == 'Cash' ? (
                                <button
                                    onClick={handlePayment}
                                    className={`${isLoading ? 'bg-primary bg-opacity-80' : 'bg-primary'}
                                          ${enablePlaceOrder ? 'text-light cursor-pointer' : 'bg-gray-400 text-light'}
                                          w-full px-4 py-2 rounded flex items-center justify-center relative`}>
                                    Place Order
                                    <div
                                        className={`absolute right-4 ${isLoading ? 'visible' : 'invisible'}`}>
                                        <RotatingLines
                                            visible={true}
                                            width={'16'}
                                            strokeColor="#fff"
                                            strokeWidth="6"
                                            animationDuration="0.75"
                                            ariaLabel="rotating-lines-loading"
                                        />
                                    </div>
                                </button>
                            ) : (
                                <button
                                    onClick={handlePayment}
                                    className={`${isLoading ? 'bg-primary bg-opacity-80' : 'bg-primary'}
                                          ${enablePlaceOrder ? 'text-light cursor-pointer' : 'bg-gray-400 text-light'}
                                          w-full px-4 py-2 rounded flex items-center justify-center relative`}>
                                    Make a Payment
                                    <div
                                        className={`absolute right-4 ${isLoading ? 'visible' : 'invisible'}`}>
                                        <RotatingLines
                                            visible={true}
                                            width={'16'}
                                            strokeColor="#fff"
                                            strokeWidth="6"
                                            animationDuration="0.75"
                                            ariaLabel="rotating-lines-loading"
                                        />
                                    </div>
                                </button>
                            )}
                            <button
                                onClick={handleBookLater}
                                className='w-full px-4 py-2 bg-primary text-light text-center rounded'>
                                Book Later
                            </button>


                        </div>
                    </div>
                </div>
            </div>
        </div>





    )
}